// extracted by mini-css-extract-plugin
module.exports = {"LoaderComponent":"Loader_LoaderComponent__Xrln1"};